export const insertGoogleAnalytics = ({ head, body }: { head: string; body: string }) => {
    if (!head || !body) return;

    const regexPattern = /<script[^>]*>([\s\S]*?)<\/script>/i;
    const matchHead = head.match(regexPattern);

    if (matchHead) {
        const gtmScript = matchHead[1];
        const headScript = document.createElement("script");
        headScript.append(gtmScript);

        document.head.append(headScript);
    }

    if (!matchHead) {
        console.error("GTM head 스크립트를 찾을 수 없습니다.");
    }

    const bodyRegexPattern = /<noscript[^>]*>([\s\S]*?)<\/noscript>/i;
    const matchBody = body.match(bodyRegexPattern);

    if (matchBody) {
        const gtmScript = matchBody[1];
        const bodyScript = document.createElement("noscript");
        bodyScript.append(gtmScript);

        document.body.append(bodyScript);
    }

    if (!matchBody) {
        console.error("GTM body 스크립트를 찾을 수 없습니다.");
    }
};
